import { formatMissingRequirements } from './formatMissingRequirements';
import styles from './missingRequirementsHint.module.scss';

type MissingRequirementsHintProps = {
  requirements: Array<string | false | null | undefined>;
  id?: string;
  className?: string;
};

export function MissingRequirementsHint({
  requirements,
  id,
  className
}: MissingRequirementsHintProps) {
  const message = formatMissingRequirements(requirements);
  if (!message) return null;

  return (
    <p
      id={id}
      className={className ? `${styles.hint} ${className}` : styles.hint}
      role="status"
      aria-live="polite"
    >
      {message}
    </p>
  );
}
